module.exports = __webpack_public_path__ + "js/legacy/ripples.worklet.499ad109.js";